<template>
  <div class="viewDetial" v-if="hackReset">
    <!-- 订单详情弹框 -->
    <a-modal title="订单详情" :width="900" :visible="visible" :footer="null" @cancel="handleCancel" :maskClosable="false">
      <div class="viewDetial-tiem">
        <div class="viewDetial-title">就诊人信息</div>
        <a-row style="height:30px">
          <a-col :span="8">
            <label>姓名：{{this.userDate.patientName }}</label>
          </a-col>
          <a-col :span="8">
            <label>年龄： {{this.userDate.patientAge }} </label>
          </a-col>
          <a-col :span="8">
            <label>所属市区：{{this.userDate.provinceName }} {{this.userDate.cityName}} {{this.userDate.disName}} </label>
          </a-col>
        </a-row>
        <a-row style="height:30px">
          <a-col :span="8">
            <label>性别：{{this.userDate.patientSex == '1'? '男' : this.userDate.patientSex == '2'? '女' : '' }} </label>
          </a-col>

          <a-col :span="8">
            <label>手机号：{{this.userDate.patientMobile }} </label>
          </a-col>
          <a-col :span="8"> 
            <!-- <label>费用：{{this.userDate.tradeType == '1'? '医保' : '自费'  }} </label> -->
          </a-col>
        </a-row>
      </div>
      <div class="viewDetial-tiem">
        <div class="viewDetial-title">处方信息</div>
        <a-row style="height:30px">
          <a-col :span="8">
            <label>就诊科室：{{this.userDate.deptName }} </label>
          </a-col>
          <a-col :span="8">
            <label>开方日期：{{this.userDate.createTime }} </label>
          </a-col>
          <a-col :span="8">
            <label>处方编号：{{this.userDate.recipeNo }} </label>
          </a-col>
        </a-row>
        <a-row style="height:30px">
          <a-col :span="8">
            <label>就诊医师： {{this.userDate.recDrName == null ? '' : this.userDate.recDrName + '/' }} {{
            this.userDate.drProtitleName }} </label>
          </a-col>
          <a-col :span="8">
            <label style="padding-left:28px">诊断： <span style="padding-right:10px"
                v-for="(item,index) in this.userDate.diaName " :key="index">{{item}}</span> </label>
          </a-col>
          <a-col :span="8">
            <label style="padding-left:28px"><span v-show="this.userDate.category == '2'">贴数：{{this.userDate.countNum}}
              </span> </label>
          </a-col>
        </a-row>
      </div>
      <div class="viewDetial-tiem">
        <div class="viewDetial-header">
          <div class="viewDetial-title">
            药方信息 <span class="viewDetial-title-notes">{{ this.record.negotiationFlag == '0' ? '内配药房' : this.record.negotiationFlag == '1' ? '外配药房' : '' }}</span>
          </div>
          <div class="viewDetial-btn" v-if="this.record.pharmacytype == '2' ">
            <a-button size="default" @click="changeModel">发货</a-button>
            <a-button size="default" @click="changeLogistics">查看物流信息</a-button>
          </div>
        </div>
        <div class="viewDetial-tiem-type">
          <a-row style="height:30px">
            <a-col :span="8">
              <label>订单编号：</label>
            </a-col>
            <a-col :span="8">
              <label>药房类型：</label>
            </a-col>
            <a-col :span="8">
              <label>订单状态：</label>
            </a-col>
          </a-row>
        </div>
        <div>
          <s-table ref="tables" :columns="columns" :data="loadData" :rowKey="(record) => record.mediId">

            <span slot="mediNum" slot-scope="text, record">
              {{ 'x' + record.mediNum}}
            </span>
            <span slot="freq" slot-scope="text, record">
              {{ record.freq + '，' +  ( record.wmOnceDosage ? '每次' +  record.wmOnceDosage + record.mediUnit : '' ) }}
            </span>

          </s-table>
          <div class="totalPrice">
            <a-row style="height:30px;line-height:30px">
              <a-col>
              </a-col>
              <a-col :span="12" style="text-align:center;">
                <label v-show="this.userDate.category != '2'">数量：{{ this.userDate.totalCount }}</label>
              </a-col>
              <a-col :span="12" style="text-align:center;">
                <label>总价：{{this.userDate.totalPrice}}</label>
              </a-col>
            </a-row>
          </div>
        </div>
      </div>
    </a-modal>
    <!-- 发货信息弹框 -->
    <a-modal title="发货信息" :width="900" :visible="deliver" okText="提交" @cancel="deliverHandleCancel"
      :maskClosable="false">
      <div class="viewDetial-tiem" style="border-bottom:1px solid #ccc">
        <a-row style="height:30px">
          <a-col :span="12">
            <label>药品订单：</label><span></span>
          </a-col>
          <a-col :span="12">
            <label>收货人：</label><span></span>
          </a-col>
        </a-row>
        <a-row style="height:30px">
          <a-col :span="12">
            <label>订单数量：</label><span></span>
          </a-col>
          <a-col :span="12">
            <label>联系电话：</label><span>18203803497</span>
          </a-col>
        </a-row>
        <a-row style="height:30px">
          <a-col :span="12">
            <label>订单金额：</label> <span style="color:red;">115</span>
          </a-col>
          <a-col :span="12" style="overflow:hidden;white-space: nowrap;text-overflow: ellipsis;">
            <label>地址：</label><a style="color:rgba(0, 0, 0, 0.65)" title=""></a>
          </a-col>
        </a-row>
        <a-row style="height:30px">
          <a-col :span="12">
            <label>发货人：</label><span></span>
          </a-col>
          <a-col :span="12">
            <label></label><span></span>
          </a-col>
        </a-row>
      </div>
      <div class="viewDetial-tiem">
        <a-form layout="inline">
          <a-row>
            <a-form-item label="物流公司：">
              <a-select style="width: 200px" placeholder="请选择物流公司" :options="logisticss"></a-select>
            </a-form-item>
          </a-row>
          <a-row>
            <a-form-item label="物流单号：">
              <a-input style="width:200px" placeholder="请输入物流单号" />
            </a-form-item>
          </a-row>
          <a-row>
            <a-form-item label="备注信息：">
              <a-input style="width:400px" placeholder="请输入备注信息" />
            </a-form-item>
          </a-row>
        </a-form>
      </div>
    </a-modal>

    <!-- 物流信息弹框 -->
    <a-modal title="物流信息" :width="900" :visible="logisticsChange" @cancel="logisticsHandleCancel" :footer="null"
      :maskClosable="false">
      <div class="viewDetial-logistics">
        <div class="viewDetial-logistics-item">
          <a-form layout="inline">
            <a-row>
              <a-form-item label="物流公司：">
                <a-select style="width: 200px" v-model="logisticsType" placeholder="请选择物流公司" :options="logistics">
                </a-select>
              </a-form-item>
            </a-row>
            <a-row>
              <a-form-item label="物流单号：">
                <a-input-search v-model="logisticsOrder" placeholder="请输入物流单号" style="width: 200px"
                  @search="onSearch" />
              </a-form-item>
            </a-row>
          </a-form>

          <a-form layout="inline">
            <a-row>
              <a-form-item label="物流公司："> </a-form-item>
            </a-row>
            <a-row>
              <a-form-item label="物流单号："> </a-form-item>
            </a-row>
            <a-row>
              <a-form-item label="状态：" style="padding-left:28px"> </a-form-item>
            </a-row>
            <a-row>
              <a-form-item label="收货人：" style="padding-left:15px;"> </a-form-item>
            </a-row>
            <a-row>
              <a-form-item label="手机号：" style="padding-left:15px;"> </a-form-item>
            </a-row>
            <a-row>
              <a-form-item label="收货地址："> </a-form-item>
            </a-row>
          </a-form>
        </div>
        <div class="viewDetial-logistics-map">
          <el-amap :center="map.center" :zoom="map.zoom" id="MapContainer">
            <!-- <el-amap-marker :position="map.center" :label="label"></el-amap-marker> -->
          </el-amap>
          <div>
            <a-timeline>
              <a-timeline-item>创建服务现场 2015-09-01</a-timeline-item>
              <a-timeline-item>初步排除网络异常 2015-09-01</a-timeline-item>
              <a-timeline-item>技术测试异常 2015-09-01</a-timeline-item>
              <a-timeline-item>网络异常正在修复 2015-09-01</a-timeline-item>
            </a-timeline>
          </div>
        </div>
      </div>

    </a-modal>
  </div>

</template>

<script>
import { STable , XDown } from '@/components'
import { recipeDetial } from '@/api/modular/interhospital/medicalorder/medicalorderManage'
export default {
  components:{
    STable,XDown
  },
	data() {
		return {
      map : {
        center: [116.397428, 39.90923],
        zoom: 15,
      },
      

      parameter : {},

			labelCol: {
				xs: { span: 24 },
				sm: { span: 5 },
			},
			wrapperCol: {
				xs: { span: 24 },
				sm: { span: 15 },
			},
			ctstampDateString: '',
			visible: false,
      deliver : false,
      logisticsChange : false,
      userDate : '',
      record : '',
      loadData: parameter => {
          return new Promise(async(resolve,reject)=>{
             const res = await recipeDetial(Object.assign(parameter, this.parameter));
             this.userDate = res.data;
             resolve(res.data.mediDetailVOList)
          })
        },
      // 表头
        columns: [
          {
            title: '药品名称',
            align: 'center',
            dataIndex: 'mediName'
          },
          {
            title: '药品编码',
            align: 'center',
            dataIndex: 'mediCode'
          },
          {
            title: '规格',
            align: 'center',
            dataIndex: 'specification'
          },
          {
            title: '用法用量',
            align: 'center',
            dataIndex: 'freq',
            scopedSlots: { customRender: 'freq' },
          },
          {
            title: '医嘱',
            align: 'center',
            dataIndex: 'drOrders'
          },
          {
            title: '数量',
            align: 'center',
            dataIndex: 'mediNum',
            scopedSlots: { customRender: 'mediNum' },
          },
          {
            title: '金额 (元)',
            align: 'center',
            dataIndex: 'kindTotalPrice'
          },
        ],
        logistics:[
          {
            value: '0',
            label: '顺丰快运',
          },
          {
            value: '1',
            label: '韵达速递',
          },
        ],
        logisticss : [],
        logisticsOrder : '',
        logisticsType : '',
        hackReset : true,
		}
	},
  created(){
    this.initMap();
  },
  
	methods: {
		// 初始化方法
		add(record) {
      console.log(record)
      this.record = record;
      if( record.id !=  this.parameter.id ){
        this.parameter.id = record.id;
      }
			this.visible = true;
      
		},

		onChangectstamp(date, dateString) {
			this.ctstampDateString = dateString
		},
    // 点击提交物流信息
    handleSubmit(){

    },
    // 关闭页面的时候通过v-if重组页面，防止组件缓存不调用接口
		handleCancel() {
			this.visible = false;
      this.hackReset = false;
      this.$nextTick(()=>{
        this.hackReset = true;
      })
		},
    // 点击切换发货
    changeModel(){
      this.visible = false;
      this.deliver = true;
    },
    // 点击物流信息
    changeLogistics(){
      this.visible = false;
      this.logisticsChange = true;
    },
    deliverHandleCancel(){
      this.deliver = false;
      this.visible = true;
    },
    logisticsHandleCancel(){
      this.logisticsChange = false;
    },
    // 搜索物流信息
    onSearch(){
      console.log('搜索')
    },
    // 初始化地图
    initMap() {
      let map = new AMap.Map("MapContainer", {
        zoomEnable: true, //是否禁止缩放
        zoom: 12, //缩放比例
        dragEnable: false, //禁止拖动
        cursor: "hand" // 鼠标在地图上的表现形式，小手
      });
      // 初始化工具条
      map.plugin(["AMap.ToolBar"], function() {
        map.addControl(new AMap.ToolBar());
      });
    }
	},
}
</script>

<style lang="less" scoped>
.viewDetial-tiem{
  margin-bottom: 10px;
}
.viewDetial-header{
  display: flex;
  .viewDetial-title{
    flex: 7;
  }
  .viewDetial-btn{
    flex: 3;
    padding: 4px 0;
  }
}
.viewDetial-title{
  height: 40px;
  line-height: 40px;
  font-family: "PingFang SC ", "PingFang SC", sans-serif;
  font-weight: 650;
  font-style: normal;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.847);
  margin-bottom: 20px;
  .viewDetial-title-notes{
    font-weight: 400;
    font-size: 13px;
    color: rgba(127, 127, 127, 0.847058823529412);
    margin-left: 15px;
  }
}
.viewDetial-tiem-type{
  height: 40px;
  line-height: 40px;
  background-color: #fff;
  color: rgb(51, 51, 51);
  background-color: #d7d7d7;
  padding: 0 20px;
  border-radius: 5px;
  
}
/deep/.s-table-tool{
  display: none;
}
.viewDetial-logistics{
  display: flex;

  .viewDetial-logistics-item{
    flex: 1;
    width: 290px;
    max-width: 290px;
  }

  .viewDetial-logistics-map{
    flex: 1;

    #MapContainer{
      height: 310px;
      width: 100%;
    }
  }

}
.totalPrice{
  line-height: 30px;
  padding: 0 15px 0 30px;
}
</style>
